import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'components/form-components/Drawer';
import ScheduleEditForm from './ScheduleEditForm';

const ScheduleEditModal = ({ handleClose, refreshList, editMode, scheduleData }) => {
  return (
    <Drawer
      title={editMode ? 'text_edit_schedule_task' : 'text_create_schedule_task'}
      handleClose={handleClose}
      classes='theme-font-inter-light'
      style={{ width: '35rem' }}
      headerClasses='p-3'
      bodyComponent={
        <ScheduleEditForm
          handleClose={handleClose}
          editMode={editMode}
          scheduleData={scheduleData}
          refreshList={refreshList}
        />
      }
    />
  );
};

ScheduleEditModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  refreshList: PropTypes.func.isRequired,
  editMode: PropTypes.string.isRequired,
  scheduleData: PropTypes.object,
};

export default ScheduleEditModal;
